import { ArticlePreviewResponse, Collection, getItemDisplayTitle } from "@authory-packages/core";
import { useWindowSize } from "../../hooks/useWindowSize";
import { getContentData } from "../../utils/article-text-utils";
import { renderArticleDate } from "../../utils/articleDateParser";
import { V3BodyGrey48 } from "../ReusableStyledComponents/V3BodyGrey48";
import { CLTitleSelectOnly, CLSourceLabel, CLTitle, CONTENT_SHORT_DATE, TitleMetaWrapper, ItemListWrapper } from "./ItemList.styles";
import { ItemImage } from "../ItemImage";
import { ContentCollectionsPanel } from "../ContentCollectionsPanel";

type ItemListProps = {
    item: ArticlePreviewResponse;
    isBusinessParent?: boolean;
    isSelectOnly?: boolean;
    collections: Collection[];
    isInfoBadgeOnly?: boolean;
};

export const ItemList = ({ item, isBusinessParent = false, isSelectOnly = false, collections, isInfoBadgeOnly = false }: ItemListProps) => {
    const size = useWindowSize();

    let useShortDate = false;

    if (size.width && size.width < CONTENT_SHORT_DATE) {
        useShortDate = true;
    }

    const TitleToUse = isSelectOnly ? CLTitleSelectOnly : CLTitle;

    const title = getItemDisplayTitle(item);
    const sourceName = isBusinessParent ? `${item.owner.firstName} ${item.owner.lastName}` : item.sourceName;

    const contentCollections = item.collections.map((it) => collections.find((col) => col.canonicalSlug === it)).filter((it) => !!it);

    return (
        <ItemListWrapper>
            <ItemImage item={item} />
            <TitleMetaWrapper $isSelectOnly={isSelectOnly}>
                <div>
                    <TitleToUse $numLines={!isInfoBadgeOnly ? 2 : 1}>{isSelectOnly ? <strong>{title}</strong> : title}</TitleToUse>
                    {isInfoBadgeOnly && !!contentCollections.length && (
                        <ContentCollectionsPanel
                            allCollections={[]}
                            isInfoBadgeOnly
                            contentCollections={contentCollections}
                            modifyItemOnCollectionCallback={() => {}}
                        />
                    )}
                </div>
                <div>
                    <V3BodyGrey48 $mobileSmallVariant>{renderArticleDate(item.date, useShortDate ? "MMM dd" : "MMM dd, yyyy")}</V3BodyGrey48>
                </div>
                <div>
                    <CLSourceLabel $mobileSmallVariant>
                        {getContentData(item.type).label} {isBusinessParent ? "by" : "at"}{" "}
                        {!isSelectOnly ? <strong>{sourceName}</strong> : sourceName}
                    </CLSourceLabel>
                </div>
            </TitleMetaWrapper>
        </ItemListWrapper>
    );
};
